import { gql } from "@apollo/client";

const REJECT_MESSENGER_CALL = gql`
  mutation rejectMessengerCall($callId: String!) {
    rejectMessengerCall(callId: $callId)
  }
`;

export default REJECT_MESSENGER_CALL;
